import { api } from './client';

export type TaskStatus = 'TODO' | 'IN_PROGRESS' | 'DONE' | 'CANCELLED';
export type TaskPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';

export interface TaskView {
  id: number;
  title: string;
  description: string | null;
  status: TaskStatus;
  priority: TaskPriority;
  labels: string[];
  sortOrder: number;
  dueDate: string | null;
  createdAt: string;
  updatedAt: string;
}

export type BoardData = Record<TaskStatus, TaskView[]>;

export interface CreateTaskRequest {
  title: string;
  description?: string;
  priority?: TaskPriority;
  labels?: string[];
  dueDate?: string;
}

export interface UpdateTaskRequest {
  title?: string;
  description?: string;
  status?: TaskStatus;
  priority?: TaskPriority;
  labels?: string[];
  dueDate?: string;
}

export interface MoveTaskRequest {
  newStatus: TaskStatus;
  newSortOrder: number;
}

export interface ReorderRequest {
  status: TaskStatus;
  taskIds: number[];
}

export const getBoard = async (): Promise<BoardData> => {
  const { data } = await api.get<BoardData>('/admin/backlog/tasks/board');
  return data;
};

export const getTask = async (id: number): Promise<TaskView> => {
  const { data } = await api.get<TaskView>(`/admin/backlog/tasks/${id}`);
  return data;
};

export const createTask = async (req: CreateTaskRequest): Promise<TaskView> => {
  const { data } = await api.post<TaskView>('/admin/backlog/tasks', req);
  return data;
};

export const updateTask = async (id: number, req: UpdateTaskRequest): Promise<TaskView> => {
  const { data } = await api.put<TaskView>(`/admin/backlog/tasks/${id}`, req);
  return data;
};

export const deleteTask = async (id: number): Promise<void> => {
  await api.delete(`/admin/backlog/tasks/${id}`);
};

export const moveTask = async (id: number, req: MoveTaskRequest): Promise<TaskView> => {
  const { data } = await api.put<TaskView>(`/admin/backlog/tasks/${id}/move`, req);
  return data;
};

export const reorderTasks = async (req: ReorderRequest): Promise<void> => {
  await api.put('/admin/backlog/tasks/reorder', req);
};
